var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-1",attrs:{"id":"mainContent","fluid":"","fill-height":"","pa-0":""}},[_c('main-header'),_c('main-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }